// extracted by mini-css-extract-plugin
module.exports = {"container":"DataTable_container__1EG7a","containerModal":"DataTable_containerModal__u-zVg","header":"DataTable_header__2y6JR","tableContainer":"DataTable_tableContainer__F4x2I"};